var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIcon8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 29.5,
    r: 12.9,
    stroke: "#3E5529",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2038 29.5C37.2038 33.1481 36.4026 36.421 35.137 38.7605C33.8586 41.1236 32.1922 42.4 30.5005 42.4C28.8088 42.4 27.1425 41.1236 25.8641 38.7605C24.5985 36.421 23.7973 33.1481 23.7973 29.5C23.7973 25.8519 24.5985 22.579 25.8641 20.2395C27.1425 17.8764 28.8088 16.6 30.5005 16.6C32.1922 16.6 33.8586 17.8764 35.137 20.2395C36.4026 22.579 37.2038 25.8519 37.2038 29.5Z",
    stroke: "#3E5529",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4424 29.7213H43.5571",
    stroke: "#3E5529",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.459 20.6823C38.3876 22.1232 34.7019 23.082 30.5 23.082C26.2982 23.082 22.6124 22.1232 20.541 20.6823",
    stroke: "#3E5529",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.541 38.3177C22.6124 36.8768 26.2981 35.918 30.5 35.918C34.7018 35.918 38.3876 36.8768 40.459 38.3177",
    stroke: "#3E5529",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon8);
export default __webpack_public_path__ + "static/media/link-icon-8.fc829cf0c26821c8e66e28b080ee4b3c.svg";
export { ForwardRef as ReactComponent };